type MeetingWithNextSession = { nextSession: string | null };

export function findNextMeeting<T extends MeetingWithNextSession>(meetings: T[]): T | undefined {
  const meetingsWithNextSession = meetings.filter(
    (m): m is T & { nextSession: string } => m.nextSession != null && m.nextSession !== '',
  );
  return meetingsWithNextSession.length > 0
    ? meetingsWithNextSession.reduce(
        (prev, curr) => (new Date(curr.nextSession) <= new Date(prev.nextSession) ? curr : prev),
        meetingsWithNextSession[0],
      )
    : undefined;
}
